import { Select, SelectOption, UserAvatar } from '@payaca/ambrosia';
import { CustomFieldHelperType } from '@payaca/custom-fields';
import { FC } from 'react';

export const UserCustomFieldInput: FC<{
  allowUnset?: boolean;
  value?: CustomFieldHelperType['user']['value'] | null;
  onChange: (value?: CustomFieldHelperType['user']['value'] | null) => void;
  users: {
    id: string;
    fullName: string;
    firstName: string;
    lastName: string;
    email?: string | null;
    colour?: string | null;
    avatarUrl?: string | null;
    deactivatedAt?: Date | string | null;
  }[];
}> = (props) => {
  const { value, onChange, users, allowUnset } = props;

  const options: SelectOption<string | null>[] = [
    ...users
      .filter((x) => !x.deactivatedAt || x.id === value?.userId)
      .map((user) => ({
        value: user.id,
        label: user.fullName,
        disabled: !!user.deactivatedAt,
      })),
    ...(allowUnset
      ? [
          {
            value: null,
            label: '-',
            disabled: false,
          },
        ]
      : []),
  ];

  return (
    <Select
      value={value?.userId || undefined}
      options={options}
      multiple={false}
      CustomSelected={({ selectedOptions }) => {
        const option = selectedOptions.length ? selectedOptions[0] : null;
        const user = option ? users?.find((u) => u.id === option.value) : null;
        return (
          <div className="flex items-center gap-2">
            {user && (
              <UserAvatar
                enableUserInfoTooltip={false}
                sizeVariant="xs"
                borderColourVariant="white"
                user={{
                  firstName: user.firstName,
                  lastName: user.lastName,
                  emailAddress: user.email,
                  userColour: user.colour,
                  imgSrc: user.avatarUrl,
                }}
              />
            )}
            {option?.label}
          </div>
        );
      }}
      CustomOption={({ option }) => {
        const user = users?.find((u) => u.id === option.value);
        return (
          <div className="flex items-center gap-2">
            {user && (
              <UserAvatar
                enableUserInfoTooltip={false}
                sizeVariant="xs"
                borderColourVariant="white"
                user={{
                  firstName: user.firstName,
                  lastName: user.lastName,
                  emailAddress: user.email,
                  userColour: user.colour,
                  imgSrc: user.avatarUrl,
                }}
              />
            )}
            {option.label}
          </div>
        );
      }}
      onChange={(value) => {
        if (value) {
          onChange({
            userId: value,
          });
        } else {
          onChange(null);
        }
      }}
    />
  );
};
